import { pick } from 'lodash'

const transformToUpdateChallengeSimpleDetailsArgs = data => ({
  ...pick(data, ['description', 'position']),
})

export default transformToUpdateChallengeSimpleDetailsArgs
